module.exports = __webpack_public_path__ + "static/media/fg-desk.78669ba2.svg";